export default "__VITE_ASSET__74da14ea__"